export function collectionListConfig(getMoney) {
    return {
        menuType: "button",
        addBtn: false,
        menuWidth: 120,
        menuAlign: "center",
        card: true,
        menu:false,
        refreshBtn:true,
        delBtn: false,
        editBtn: false,
        align: "center",
        searchMenuSpan: 8,
        columnBtn: false,
        searchBtn: true,
        index: true,
        indexLabel: "序号",
        selection:true,
        selectionWidth:45,
        searchShow: false,
        border:true,
        column: [
            {
                label: '项目名称',
                prop: 'search',
                width: '200',
                slot: true,
                hide: true,
                overHidden: true,
                search: true,
            },            
            {
                label: '项目名称',
                prop: 'projectName',
                width: '200',
                overHidden: true,
                slot: true,
                // search: true,
            },{
                label: '保理合同',
                prop: 'contractName',
                width: '150',
                search: true,
                overHidden: true
            },{
                label: '款项类型',
                hide: true,
                search: true,
                type: 'select',
                prop: 'collectionType',
                dicUrl: "/api/blade-system/dict-biz/dictionary?code=factoring_collection_type",
                props: {
                  label: "dictValue",
                  value: "dictKey",
                }
            },{
                label: '核销状态',
                prop: 'isWriteoff',
                search: true,
                type: 'select',
                dicUrl: "/api/blade-system/dict-biz/dictionary?code=factoring_writeoff",
                props: {
                  label: "dictValue",
                  value: "dictKey",
                },
                formatter: (row, value, label, column)=> {
                    return value == 0?'未核销':'已核销'
                }
            },{
                label: '记账状态',
                prop: 'isBooking',
                type: 'select',
                search: true,
                dicUrl: "/api/blade-system/dict-biz/dictionary?code=bookkeeping_state",
                props: {
                  label: "dictValue",
                  value: "dictKey",
                },                
                formatter: (row, value, label, column)=> {
                    return value == 0?'未记账':'已记账'
                }
            },{
                label: '款项类型',
                prop: 'collectionTypeStr'
            },{
                label: '对应放款批次',
                prop: 'collectionBatch',
                width: '150',
                overHidden: true,                
                formatter: (row, value, label, column)=> {
                    if(value != '' && value != -1) {
                        return `第${value}批`
                    }else {
                        return "-"
                    }
                } 
            },{
                label: '付款方',
                prop: 'custName',
                width: '150',
                overHidden: true
            },{
                label: '保理商',
                prop: 'formAccountingEntityStr',
                width: '200',
                overHidden: true
            },{
                label: '应收金额（元）',
                prop: 'collectionPlanMoney',
                width: '120',
                overHidden: true,
                formatter: (row, value, label, column)=> {
                    return `${getMoney(Number(value))}元`
                }
            },{
                label: '计划收款日期',
                prop: 'collectionPlanDate',
                width: '100',
                overHidden: true
            },
            {
                label: '计划收款日期范围',
                prop: 'timePic',
                type:'daterange',
                searchSpan:12,
                searchLabelWidth:130,
                searchRange:true,
                search:true,
                hide:true
            }, 
            {
                label: '核销人员',
                prop: 'writeoffUserName'
            },{
                label: '核销时间',
                prop: 'writeoffTime',
                width: '180',
                overHidden: true
            }
        ]
    }
}

export function collectionInfoDialogConfig() {
    return [
        {
            label: '项目名称',
            prop: 'projectName',
            span: '12'
        },{
            label: '业务类型',
            prop: 'projectTypeStr',
            span: '12'
        },{
            label: '付款方',
            prop: 'custName',
            span: '12'
        },{
            label: '保理商',
            prop: 'formAccountingEntityStr',
            span: '12'
        },{
            label: '保理合同',
            prop: 'contractName',
            span: '12'
        },{
            label: '对应当款批次',
            prop: 'collectionBatch',
            span: '12',
            formatter: (label, value)=> {
                return `第${value}批`
            }
        },{
            label: '业务主办',
            prop: 'managerUserName',
            span: '12'
        },{
            label: '业务协办',
            prop: 'assistUserName',
            span: '12'
        }
    ]
}

export function writeOffConfig(getMoney) {
    return [
        {
            label: '款项类型',
            prop: 'collectionTypeStr',
            span: '14'
        },{
            label: '应收金额',
            prop: 'collectionPlanMoney',
            span: '14',
            formatter: (label, value) => {
                return `${getMoney(Number(value))}元`
            }
        },{
            label: '计划收款时间',
            prop: 'collectionPlanDate',
            span: '14'
        }
    ]
}

export function collectionInConfig(getMoney) {
    return [
        {
            label: '收款账号',
            prop: 'collectionBankStr',
            span: '14'
        },{
            label: '收款金额',
            prop: 'collectionMoney',
            span: '14',
            formatter: (label, value) => {
                return `${getMoney(Number(value))}元`
            }
        },{
            label: '收款日期',
            prop: 'collectionDate',
            span: '14'
        }
    ]
}
export function paymentListConfig() {
    return {
        labelWidth: 240,
        backgroundColor: '#f7f9fe',
        align: 'center',
        submitBtn: false,
        emptyBtn: false,
        menuBtn: false,
        menu:false,
        column: [
            {
                label: '收款帐号',
                prop: 'collectionBankId',
                formslot: true,
                span: 24,
                rules: [
                    {
                        required: true,
                        message: '请选择付款帐号',
                    }
                ]
            },
            {
                label: '入账金额',
                type: 'input',
                prop: 'collectionMoney',
                span: 24,
                append: '元',
                rules: [
                    {
                        required: true,
                        message: '请输付款金额',
                    }
                ]
            },
            {
                label: '入账日期',
                type: 'date',
                prop: 'collectionDate',
                format:'yyyy-MM-dd',
                valueFormat:'yyyy-MM-dd',
                span: 24,
                rules: [
                    {
                        required: true,
                        message: '请选择付款日期',
                    }
                ]
            },
        ]
    }
}

export function chargeBackConifg() {
    return {
        labelWidth: 120,
        backgroundColor: '#f7f9fe',
        align: 'center',
        submitBtn: false,
        emptyBtn: false,
        menuBtn: false,
        menu:false,
        column: [
            {
                label: '原因描述',
                prop: 'remarks',
                type: 'textarea',
                span: 24,
                rules: [
                    {
                        required: true,
                        message: '请输入原因描述',
                        trigger: "blur"
                    }
                ]
            }
        ]
    }
}

export function filterConfig(selectPersonClick,selectDeptClick) {
    return {
        labelWidth: 120,
        column: [
            {
                label: '搜索查询',
                prop: 'projectName',
            },{
                label: "款项类型",
                type: 'select',
                prop: 'collectionType',
                dicUrl: "/api/blade-system/dict-biz/dictionary?code=factoring_collection_type",
                props: {
                  label: "dictValue",
                  value: "dictKey",
                }
            },{
                label: '收款方',
                prop: 'cust',
                formslot: true
            },{
                label: "应付金额",
                prop: "collectionPlanMoney",
                formslot: true,
            },{
                label: "计划付款日期",
                prop: "collectionPlanDate",
                type: 'date'
            },{
                label: '客户经理',
                prop: 'managerUserName',
                click: () => {
                  selectPersonClick('managerUserName');
                }
            },{
                label: '申请部门',
                prop: 'managerDeptName',
                click: () => {
                  selectDeptClick();
                }        
            },           
            {
                label: '核销状态',
                prop: 'writeoff',
                type: 'select',
                dicUrl: "/api/blade-system/dict-biz/dictionary?code=factoring_writeoff",
                props: {
                  label: "dictValue",
                  value: "dictKey",
                }
            },
            {
                label: '记账状态',
                prop: 'booking',
                type: 'select',
                dicUrl: "/api/blade-system/dict-biz/dictionary?code=bookkeeping_state",
                props: {
                  label: "dictValue",
                  value: "dictKey",
                },
            },
            {
                label: '核销人员',
                prop: 'writeoffUserName',
                click: () => {
                  selectPersonClick('writeoffUser');
                }
            },{
                label: '核销日期',
                prop: 'writeoffTime',
                formslot: true
            }
        ]
    }
}